import { IndustryContractTemplateContractTypes } from "./IndustryContractTemplateContractTypes";

export class IndustryContractTemplate {
  industryContractTemplateId: number = 0;
  payerGroupName: string = "";
  networkName: string = "";
  industryContractTemplateContractTypes: IndustryContractTemplateContractTypes[] = [];
  contractTypeIds: number[] = [];
}
